import { Injectable } from '@angular/core';
import { MARKETINFO } from 'app/model/marketinfo.model';

@Injectable()
export class MarketPDFService {
  constructor() {}

  generateMarket(marketGroup: MARKETINFO) {
    let market =
      (marketGroup.markets.in_markets_SME ? 'SME,' : '') +
      (marketGroup.markets.in_markets_CORP ? 'CORP,' : '') +
      (marketGroup.markets.in_markets_CONS ? 'CONS,' : '') +
      (marketGroup.markets.in_markets_OEM ? 'OEM,' : '') +
      (marketGroup.markets.in_markets_GOV ? 'GOV,' : '') +
      (marketGroup.markets.in_markets_EDU ? 'EDU,' : '') +
      (marketGroup.markets.in_markets_WEB ? 'WEB,' : '') +
      (marketGroup.markets.in_markets_FIN ? 'FIN,' : '') +
      (marketGroup.markets.in_markets_TELE ? 'TELE,' : '') +
      (marketGroup.markets.in_markets_OTH ? 'OTH' : '');

    let products =
      (marketGroup.products.in_principal_products_OEM ? 'OEM,' : '') +
      (marketGroup.products.in_principal_products_PC ? 'PC,' : '') +
      (marketGroup.products.in_principal_products_Peripherals
        ? 'Peripherals,'
        : '') +
      (marketGroup.products.in_principal_products_Consumables
        ? 'Consumables,'
        : '') +
      (marketGroup.products.in_principal_products_Networking
        ? 'Networking,'
        : '') +
      (marketGroup.products.in_principal_products_Infrastructure
        ? 'Infrastructure,'
        : '') +
      (marketGroup.products.in_principal_products_Telecommunications
        ? 'Telco,'
        : '') +
      (marketGroup.products.in_principal_products_Software ? 'Software,' : '') +
      (marketGroup.products.in_principal_products_Cloud ? 'Cloud,' : '') +
      (marketGroup.products.in_principal_products_Solutions
        ? 'Solutions,'
        : '') +
      (marketGroup.products.in_principal_products_Services ? 'Services,' : '') +
      (marketGroup.products.in_principal_products_Other ? 'Other' : '');

    let focus = marketGroup.in_focus_size;
    let annuity = marketGroup.in_percent_annuity_based;

    let prodDecs = marketGroup.in_other_product_desc;
    let markDecs = marketGroup.in_other_market_desc;

    // debugger;
    // console.log(prodDecs, markDecs, 'description');
    // console.log(products, market)
    if (market.indexOf('OTH') == 0 && markDecs.length != 0) {
      market = market.replace('OTH', markDecs);
    }

    if (products.indexOf('Other') == 0 && prodDecs.length != 0) {
      products = products.replace('Other', prodDecs);
    }

    return {
      style: 'tableExample',
      table: {
        widths: ['50%', '25%', '25%'],
        body: [
          [
            { text: 'Principal Products Purchased:', style: 'questions' },
            {
              colSpan: 2,
              text: 'Which Market Does Your Business Operate Within:',
              style: 'questions'
            },
            ''
          ],

          [
            { text: ' ' + products, italics: true },
            {
              colSpan: 2,
              text: ' ' + market,
              italics: true
            },
            ''
          ],
          [
            { text: 'End User Focus Size:', style: 'questions' },
            {
              colSpan: 2,
              text: 'What % Of Your Business In Annuity Based?',
              style: 'questions'
            },
            ''
          ],

          [
            { text: ' ' + focus, italics: true },
            {
              colSpan: 2,
              text: ' ' + annuity,
              italics: true
            },
            ''
          ]
        ]
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/services/pdf/marketpdf.generation.ts